import { Container } from '#app/components/ui'
import { PrimaryFeaturesTabs } from '../primary-features-tabs'

export default function PrimaryFeatures() {
	return (
		<section
			id="features"
			aria-label="Features for running your books"
			className="relative overflow-hidden bg-emerald-600 pb-28 pt-20 sm:py-32"
		>
			<Container className="relative">
				<div className="max-w-2xl md:mx-auto md:text-center xl:max-w-none">
					<h2 className="font-display text-3xl tracking-tight text-white sm:text-4xl md:text-5xl">
						Everything you need to run your event flawlessly.
					</h2>
					<p className="mt-6 text-lg tracking-tight text-emerald-100">
						Manage everything for an event from team members and vendors to the
						timline itself.
					</p>
				</div>
				<PrimaryFeaturesTabs />
			</Container>
		</section>
	)
}
